(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SEL = 'h1,h2,h3,p,figure,img,blockquote,.omd-com-stat,[class*="stat"],a[href][style],button';
  var SKIP = '.om-scrub,.om-scrub *,header,footer,nav,.omr-skip,.omr-skip *';

  function start() {
    var main = document.querySelector('main') || document.body;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('omr-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });

    var sections = main.querySelectorAll('.shopify-section, section');
    var tagged = 0;
    sections.forEach(function (sec) {
      if (sec.matches(SKIP) || sec.closest('.om-scrub')) return;
      var n = 0;
      sec.querySelectorAll(SEL).forEach(function (el) {
        if (n >= 8) return;
        if (el.matches(SKIP)) return;
        if (el.closest('[data-omr]')) return;          // nada anidado
        if (!el.textContent.trim() && !el.querySelector('img,svg') && el.tagName !== 'IMG') return;
        el.setAttribute('data-omr', String(Math.min(n, 3)));
        io.observe(el);
        n++; tagged++;
      });
    });

    if (tagged) document.documentElement.classList.add('om-rv');

    // Red de seguridad: si algo quedara invisible pasados 6 s, se muestra igualmente.
    setTimeout(function () {
      document.querySelectorAll('[data-omr]:not(.omr-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('omr-in');
      });
    }, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
